import Vec2 from 'vec2';

import { LongestHorizontalTopEdge } from './positionShapeLabel.types';

import {
  addVectors,
  getOutlinePointsFromShape,
  getTopLeftVector,
} from '~/core/helpers';
import { DrawingShape } from '~/core/models';

export const getShapeTextPos = (
  shape: DrawingShape,
  longestHorizontalTopEdge: LongestHorizontalTopEdge,
  requiredEdgeLength: number
) => {
  let shapeTextPos: Vec2 | undefined;

  if (longestHorizontalTopEdge.length) {
    // there is at least one horizontal top and we will use the longest one
    shapeTextPos = longestHorizontalTopEdge.nextBestFlatTop;
  } else {
    // find the top most point and it's radius center point, then adjust x from there
    const outlinePoints = getOutlinePointsFromShape(shape);
    const topLeft = getTopLeftVector(outlinePoints);
    const topmostCorner = Object.values(shape.cornerMap).find(
      (item) => item.coords === topLeft
    );

    // Find edge that starts with the topmost corner
    const topmostEdge = shape.drawingEdges.find(
      (edge) => edge.startCornerId === topmostCorner?.id
    );

    // Find corner adjacent to the left of the topmost corner
    // i.e. the corner that ends the edge started by the topmost corner
    const leftyTopmostCorner = Object.values(shape.cornerMap).find(
      (corner) => corner.id === topmostEdge?.endCornerId
    );

    if (leftyTopmostCorner && leftyTopmostCorner.size) {
      const EDGE_LENGTH_FACTOR = 5; // arbitrary number that looks good in design area

      shapeTextPos = new Vec2(
        leftyTopmostCorner.coords.x + requiredEdgeLength / EDGE_LENGTH_FACTOR,
        leftyTopmostCorner.coords.y - requiredEdgeLength / EDGE_LENGTH_FACTOR
      );
    } else {
      shapeTextPos = addVectors(topLeft, new Vec2(-15, 13));
    }
  }

  return shapeTextPos;
};
